import SampleProfilesPageReducer from './SampleProfilesPageReducer';

export default from './SampleProfilesPageContainer';
export const SampleProfilesPageReducers = {
  SampleProfilesPageReducer,
};
